// MessageChannel works across browser tabs and installed PWA windows, including
// clients that do not share a BroadcastChannel or localStorage session.
export function requestWorkerReply(target, message, timeoutMs = 4000) {
  return new Promise((resolve) => {
    const channel = new MessageChannel();
    const finish = (value) => {
      clearTimeout(timer);
      channel.port1.close();
      channel.port2.close();
      resolve(value);
    };
    const timer = setTimeout(() => finish(null), timeoutMs);
    channel.port1.onmessage = (event) => finish(event.data);
    try {
      target.postMessage(message, [channel.port2]);
    } catch {
      finish(null);
    }
  });
}

export async function coordinateWorkerUpdate(workerScope) {
  const windows = await workerScope.clients.matchAll({ type: 'window', includeUncontrolled: true });
  const scope = workerScope.registration.scope;
  const clients = windows.filter((client) => client.url.startsWith(scope));
  const responses = await Promise.all(clients.map((client) =>
    requestWorkerReply(client, { type: 'PREPARE_APP_UPDATE' })));
  // A suspended or older client that cannot acknowledge must never be assumed safe.
  if (responses.some((response) => response?.safe !== true)) return 'blocked';
  const current = await workerScope.clients.matchAll({ type: 'window', includeUncontrolled: true });
  if (current.some((client) => client.url.startsWith(scope) && !clients.some(({ id }) => id === client.id))) {
    return 'blocked';
  }
  const committed = await Promise.all(clients.map((client) =>
    requestWorkerReply(client, { type: 'COMMIT_APP_UPDATE' })));
  if (committed.some((response) => response?.safe !== true)) {
    clients.forEach((client) => client.postMessage({ type: 'CANCEL_APP_UPDATE' }));
    return 'blocked';
  }
  await workerScope.skipWaiting();
  return 'activating';
}
